import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const NOTICE_IMAGE = '/notice/runningpoint-notice-stock-split.png'

const Contact = () => {
    const [isNoticeOpen, setIsNoticeOpen] = useState(false)

    useEffect(() => {
        if (!isNoticeOpen) {
            return undefined
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsNoticeOpen(false)
            }
        }

        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        window.addEventListener('keydown', handleKeyDown)

        return () => {
            document.body.style.overflow = previousOverflow
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [isNoticeOpen])

    return (
        <Container id="contact">
            <Round />
            <Typography variant="h3" sx={{ textAlign: 'center', marginTop: '-100px' }}>
                Contact
            </Typography>
            <Box sx={{ height: '100px', backgroundColor: '#ffffff' }}></Box>
            <DetailContainer>
                {/* <Email>
                    <li>
                        <div>
                            <img src="/images/contact.png" alt="컨택트 아이콘"/>
                            투자문의 | hello@runpoint.co.kr
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="/images/contact.png" alt="컨택트 아이콘"/>
                            협업문의 | info@runpoint.co.kr
                        </div>
                    </li>
                </Email> */}
                <CopyRight>
                    <li>
                        <div>
                            <img src="/images/contact.png" alt="컨택트 아이콘"/>
                            투자문의 | taehun6820@runpoint.co.kr
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="/images/contact.png" alt="컨택트 아이콘"/>
                            협업문의 | info@runpoint.co.kr
                        </div>
                    </li>
                    <br/>
                    <p>
                        러닝포인트 | 대표 : 박태훈
                    </p>
                    <p>
                        사업자등록번호 : 515-81-56247
                    </p>
                    <p>
                        통신판매업 신고 제 2020-서울마포-4175 호
                    </p>
                    <p>
                        주소 : (본사) 서울특별시 금천구 가산디지털1로 205-15, 1007호
                    </p>
                    <br/>
                    <span>&copy; RunningPoint Inc.</span>
                    <NoticeButton type="button" onClick={() => setIsNoticeOpen(true)}>
                        공고
                    </NoticeButton>
                </CopyRight>
            </DetailContainer>
            <Box sx={{ height: '300px', backgroundColor: '#ffffff' }}></Box>
            {isNoticeOpen && (
                <NoticePopup
                    role="dialog"
                    aria-modal="true"
                    aria-label="(주)러닝포인트 공고문"
                    onClick={() => setIsNoticeOpen(false)}
                >
                    <NoticeDialog onClick={(event) => event.stopPropagation()}>
                        <NoticeHeader>
                            <NoticeTitle>공고</NoticeTitle>
                            <CloseButton type="button" onClick={() => setIsNoticeOpen(false)} aria-label="공고 팝업 닫기">
                                닫기
                            </CloseButton>
                        </NoticeHeader>
                        <NoticeBody>
                            <NoticeImageFrame>
                                <NoticeImage src={NOTICE_IMAGE} alt="(주)러닝포인트 공고문" />
                            </NoticeImageFrame>
                        </NoticeBody>
                    </NoticeDialog>
                </NoticePopup>
            )}
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: #000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    @media screen and (max-width: 1100px){
        // height: 750px;
    }
` 
const Round = styled.div`
    background: url('/images/round.png') no-repeat;
    background-size: 100% 100%;
    width: 141px;
    height: 295px;
    transform: rotate(-90deg);
    position: relative;
    top: -150px;
    @media screen and (max-width: 1100px){
        top: -160px;
    }
`
const DetailContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    text-align: center;
    justify-content: center; 
    font-size: 18px;
    img{
        width: 25px;
        height: 18px;
        position: relative;
        top: 3px;
        right: 5px;
        @media screen and (max-width: 1100px){
            top: -5px;
        }
    }
    @media screen and (max-width: 1100px){
        display: flex;
        flex-direction: column;
    }
`  
const Email = styled.ul`
    list-style: none;
    margin-bottom: 100px;
    li{
        margin-top: 10px;
        @media screen and (max-width: 1100px){
            font-size: 37px;
        }
    }
   
`
const CopyRight = styled.div`
    list-style: none;
    font-size: 20px;
    @media screen and (max-width: 1100px){
        font-size: 37px;
    }
`

const NoticeButton = styled.button`
    display: block;
    margin-top: 10px;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-decoration: none;
    cursor: pointer;
    width: 100%;

    &:hover {
        text-decoration: underline;
    }
`

const NoticePopup = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: rgba(0, 0, 0, 0.72);
    color: #111111;
`

const NoticeDialog = styled.div`
    width: min(92vw, 820px);
    max-height: calc(100vh - 48px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 20px 70px rgba(0, 0, 0, 0.35);
`

const NoticeHeader = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 20px;
    border-bottom: 1px solid #e5e5e5;
`

const NoticeTitle = styled.strong`
    font-size: 18px;
    line-height: 1.3;
`

const CloseButton = styled.button`
    flex: 0 0 auto;
    padding: 8px 12px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    background-color: #ffffff;
    color: #111111;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;

    &:hover {
        background-color: #f2f2f2;
    }
`

const NoticeBody = styled.div`
    overflow: auto;
    padding: 12px;
    background-color: #f5f5f5;
`

const NoticeImageFrame = styled.div`
    width: 100%;
    max-width: 760px;
    aspect-ratio: 734 / 708;
    overflow: hidden;
    margin: 0 auto;
    background-color: #ffffff;
`

const NoticeImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
`

export default Contact
